/**
 * API client for activity editing
 */

/**
 * Update an existing curriculum activity
 * @param {string|number} childId - The child ID
 * @param {string|number} activityId - The activity ID
 * @param {Object} activityData - Activity configuration data
 * @param {string} csrfToken - CSRF token
 * @returns {Promise<Object>} Updated activity
 */
export async function updateActivity(childId, activityId, activityData, csrfToken) {
  const response = await fetch(`/api/children/${childId}/curriculum/activities/${activityId}`, {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': csrfToken,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      curriculum_activity: activityData
    })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || error.error || 'Failed to update activity');
  }

  return response.json();
}
